/**
 * Returns true if the two arrays contain the same elements regardless of
 * order, compared via their sorted JSON representations.
 *
 * Copies each array before sorting, so the inputs are NOT mutated — callers
 * frequently pass frozen/read-only arrays (e.g. RTK Query / Immer state, or a
 * derived options list), and an in-place `.sort()` on those throws
 * "Cannot assign to read only property". Note the sort is lexicographic
 * (default `Array.prototype.sort`), which is fine for the order-insensitive
 * equality these callers need but means arrays of plain objects won't compare
 * meaningfully (every object stringifies to `"[object Object]"`).
 *
 * @param arr1 - First array to compare (not mutated).
 * @param arr2 - Second array to compare (not mutated).
 * @returns `true` if both arrays contain the same elements irrespective of order.
 *
 * @example
 * deepCompareArrays(['a', 'b'], ['b', 'a']); // true
 * deepCompareArrays([1, 2], [1, 2, 3]); // false
 */
export function deepCompareArrays(arr1, arr2) {
    const sorted1 = [...(arr1 ?? [])].sort();
    const sorted2 = [...(arr2 ?? [])].sort();

    return JSON.stringify(sorted1) === JSON.stringify(sorted2);
}
